var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("알 수 없는 페이지")]),_c('p',[_vm._v("이 페이지는 존재하지 않습니다.")]),_c('p',[_vm._v("대신, 이 멋진 작품을 감상해주세요:")]),_c('p',[_c('awesome',{attrs:{"light":_vm.darkMode}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }